import type { PromoCampaign } from './types';
import { MEU_TIM } from '../../constants/channels';

// Campanhas de datas iguais da TIM (10/10, 11/11, 12/12). A elegibilidade vem do
// planBenefits.category cadastrado no BFF; aqui ficam a janela, o canal e os textos.
// Horário de Brasília fixo em -03:00 (sem horário de verão desde 2019).
export const PROMO_CAMPAIGNS: PromoCampaign[] = [
  {
    period: {
      startDate: '2026-10-10T10:00:00-03:00',
      endDate: '2026-10-10T22:00:00-03:00',
    },
    conditions: { category: 'pre', channel: MEU_TIM, minFace: 3000 },
    tag: 'Oferta dia 10.10',
    // bonusTag, infoText e checkoutBonus descrevem o mesmo bônus (volume e
    // validade): ao trocar um, conferir os outros dois
    bonusTag: '+ 10 GB de bônus',
    infoText: 'Bonificações válidas por 7 dias.',
    checkoutBonus: '10 GB válido por 7 dias',
  },
];
